import BsIcon from "./BsIcon";

export default BsIcon;